const courseUrl = "https://codefussion.tech/elearning/courses/"

export { courseUrl }
